import * as Yup from 'yup';
import { isFutureDate } from './validationHelpers';

const baseVehicleSchema = Yup.object().shape({
  vin: Yup.string()
    .required('VIN Number is required')
    .matches(
      /^[A-HJ-NPR-Z0-9]{17}$/,
      'VIN number must be exactly 17 characters and contain only alphanumeric characters (no I, O, or Q)'
    ),
  make: Yup.string()
    .required('Make is required')
    .max(100, 'Make should not exceed 100 characters'),
  model: Yup.string()
    .required('Model is required')
    .max(100, 'Model should not exceed 100 characters'),
  model_year: Yup.number()
    .required('Year is required')
    .min(2015, 'Year must be 2015 or later')
    .max(new Date().getFullYear(), `Year cannot be later than ${new Date().getFullYear()}`),
  mileage: Yup.number()
    .required('Mileage is required')
    .positive('Mileage must be a positive number'),
});

const baseLoanSchema = Yup.object().shape({
  current_monthly_payment: Yup.string()
    .required('Monthly Loan Payment is required'),
  current_payoff: Yup.string()
    .required('Remaining Loan is required'),
  next_payment_date: Yup.date()
    .required('Next Payment Date is required')
    .typeError('Next Payment Date must be a valid date')
    .test('is-future', 'Next Payment Date must be in the future', isFutureDate),
  lien_holder: Yup.string()
    .required('Current Lender is required')
    .max(100, 'Current Lender should not exceed 100 characters'),
});

export const stepFiveSchema = Yup.object().shape({
  vin: baseVehicleSchema.fields.vin,
  make: baseVehicleSchema.fields.make,
  model: baseVehicleSchema.fields.model,
  model_year: baseVehicleSchema.fields.model_year,
  mileage: baseVehicleSchema.fields.mileage,
  current_monthly_payment: baseLoanSchema.fields.current_monthly_payment,
  current_payoff: baseLoanSchema.fields.current_payoff,
  next_payment_date: baseLoanSchema.fields.next_payment_date,
  lien_holder: baseLoanSchema.fields.lien_holder,
  comments: Yup.string(),

  // 🔥 NEW: Validation for additional entries
  additional_vehicles: Yup.array().of(baseVehicleSchema),
  additional_loans: Yup.array().of(baseLoanSchema),
});
